


















































/* Created- 28 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import PublicationModelForm from "@/Ui-Components/Title/PublicationForm.vue";
import { PublicationModel, PubIssueDTO, IssueModel, IssuePropertiesDTO, IssuePropertiesDTOVisibility } from "../../Generated/ParticaAPI";
import { PublicationService, IPublicationService } from "../../BusinessServices/publication";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonListV2.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaCardXl from "@/Ui-Components/Common/Container/ParticaCardMid.vue";
import IssueList from "@/Ui-Components/Title/IssueList/IssueListv2.vue";
import { INavigationService } from "../../NavigationServices/navigation";
import { eParticaAction, getActionName, ParticaEvent } from "../../Models/ParticaEvent";
import { ButtonConfig, ButtonType } from "../../Models/Buttons";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaTitleBase from "../Base/ParticaTitleBase.vue";
import { IIssueService } from "../../BusinessServices/issue";
import IssuePropertiesForm from "@/Ui-Components/Issue/IssueForm.vue";

@Component(
	{
		name: "ParticaTitle",
		components: {
			ParticaError,
			PublicationModelForm,
			ButtonList,
			ParticaColumnContainer,
			ParticaRowContainer,
			ParticaCard,
			ParticaCardXl,
			IssueList,
			ParticaView,
			IssuePropertiesForm
		}
	})
export default class ParticaTitle extends ParticaTitleBase {
	private data: PublicationModel = new PublicationModel();
	private issues: PubIssueDTO[] = [];
	private publicationService: IPublicationService;
	private issueService: IIssueService;
	@Prop() private id: number;
	private buttons: ButtonConfig[] = [];
	private issuebuttons: ButtonConfig[] = [
		{ label: "Publish", action: eParticaAction.ISSUE_PUBLISH, type: ButtonType.Highlight } as ButtonConfig,
		{ label: "Open in new tab", action: eParticaAction.ISSUE_NEWTAB_SELECT, type: ButtonType.Normal } as ButtonConfig,
	];
	private drawer: boolean = false;
	private selectedissue: IssueModel = new IssueModel();
	private selectedissueprops: IssuePropertiesDTO = new IssuePropertiesDTO();
	private urls: string[] = [];
	private titlebuttons: ButtonConfig[] = [
		{
			label: "Add",
			action: eParticaAction.ISSUE_ADD,
			type: ButtonType.Normal,
			title: "Add Issues",
			help: "Create new issues/editions for this title."
		} as ButtonConfig,
		{
			label: "Manage",
			action: eParticaAction.PUBLICATION_SECTION_MANAGER,
			type: ButtonType.Normal,
			title: "Sections",
			help: "Manage the content sections for this title."
		} as ButtonConfig,
	];



	private advancedbuttons: ButtonConfig[] = [
		{
			label: "Publish All",
			action: eParticaAction.PUBLICATION_PUBLISH_ISSUES,
			type: ButtonType.Normal,
			title: "Publish Issues",
			help: "Make all issues/editions, that are not live, in this title available on this website."
		} as ButtonConfig,
		{
			label: "Un-Publish All",
			action: eParticaAction.PUBLICATION_UNPUBLISH_ISSUES,
			type: ButtonType.Normal,
			title: "Un-Publish Issues",
			help: "Remove all live issues/editions from this website."
		} as ButtonConfig,
		{
			label: "Re-Publish",
			action: eParticaAction.PUBLICATION_REPUBLISH_ISSUES,
			type: ButtonType.Normal,
			title: "Re-Publish Issue content",
			help: "Re-publish content (articles, TOC) for all issues without making any live / unlive."
		} as ButtonConfig,
		{
			label: "Import metadata",
			action: eParticaAction.PUBLICATION_IMPORT_METADATA,
			type: ButtonType.Normal,
			title: "Import Metadata",
			help: "Import issue metadata from a google sheet."
		} as ButtonConfig,
		{
			label: "Log",
			action: eParticaAction.PUBLICATION_LOG,
			type: ButtonType.Normal,
			title: "PublicationLog",
			help: "View Publication API log"
		} as ButtonConfig,
		{
			label: "Scheduled Tasks",
			action: eParticaAction.PUBLICATION_SCHEDULED_TASKS,
			type: ButtonType.Normal,
			title: "ScheduledTasks",
			help: "Manage tasks for this publication."
		} as ButtonConfig
	];
	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.ISSUE_PUBLISH: {
					if (this.selectedissueprops.visibility === IssuePropertiesDTOVisibility.NotVisible) {
						await this.issueService.PublishIssue(this.selectedissue.id as number, 1);
						this.issuebuttons[0].label = "Unpublish";
						const found = this.issues.find(i => i.isssueId === this.selectedissue.id);
						if (found !== undefined) {
							found.live = 1;
						}
						this.ShowSnackbar("Issue made live, It may take a couple of minutes to appear on the website.");
					} else {
						await this.issueService.PublishIssue(this.selectedissue.id as number, 0);
						this.issuebuttons[0].label = "Publish";
						const found = this.issues.find(i => i.isssueId === this.selectedissue.id);
						if (found !== undefined) {
							found.live = 0;
						}
						this.ShowSnackbar("Issue removed from website, It may take a couple of minutes to reflect on the website.");
					}
					this.drawer = false;
					break;
				}

				case eParticaAction.RIGHT_MOUSE_CLICK: {
					this.selectedissue = await this.issueService.getIssue(event.item.isssueId as number);
					this.selectedissueprops = await this.issueService.getIssueProperties(event.item.isssueId as number);
					if (this.selectedissueprops.visibility === IssuePropertiesDTOVisibility.Visible) {
						this.issuebuttons[0].label = "Unpublish";
					} else {
						this.issuebuttons[0].label = "Publish";
					}
					this.drawer = true;
					break;
				}
				case eParticaAction.ISSUE_NEWTAB_SELECT: {
					if (this.selectedissue !== undefined) {
						this.newtab("issue", { id: (this.selectedissue.id as number).toString() });
					}
					break;
				}
				case eParticaAction.PUBLICATION_SECTION_MANAGER: {
					this.navigate("sectionmanager", { id: this.id.toString() });
					break;
				}
				case eParticaAction.PUBLICATION_LOG: {
					this.navigate("publicationlog", { id: this.id.toString() });
					break;
				}
				case eParticaAction.ISSUE_ADD: {
					this.navigate("issuecreatepdf", { id: this.id.toString() });
					break;
				}
				case eParticaAction.ISSUE_SELECT: {
					this.navigate("issue", { id: event.item.isssueId.toString() });
					break;
				}
				case eParticaAction.PUBLICATION_IMPORT_METADATA: {
					this.navigate("metadataimport", { id: this.id.toString() });
					break;
				}
				case eParticaAction.PUBLICATION_SCHEDULED_TASKS: {
					this.navigate("scheduledtasks", { id: this.id.toString() });
					break;
				}
				case eParticaAction.CONFIRM_PUBLICATION_PUBLISH_ISSUES: {
					this.dialog.show = false;
					await this.publicationService.publishIssues(this.id);
					await this.init();
					break;
				}
				case eParticaAction.CONFIRM_PUBLICATION_REPUBLISH_ISSUES: {
					this.dialog.show = false;
					await this.publicationService.republishIssues(this.id);
					break;
				}
				case eParticaAction.PUBLICATION_REPUBLISH_ISSUES: {
					this.dialog.title = "RePublish multiple issues.";
					this.dialog.message = `You have chosen to republish all the issues for this publication. This will republish the issues for your site in the background using a background process.`;
					this.dialog.action = eParticaAction.CONFIRM_PUBLICATION_REPUBLISH_ISSUES;
					this.dialog.show = true;
					break;
				}
				case eParticaAction.PUBLICATION_PUBLISH_ISSUES: {
					const notlives = this.issues.filter(i => i.live === 0 && i.issueStatus === 1);
					if (notlives.length > 5) {
						this.dialog.title = "Publish multiple issues.";
						this.dialog.message = `You have chosen to make ${notlives.length} issue live. This will add the issues to your site in the background using a background process.`;
						this.dialog.action = eParticaAction.CONFIRM_PUBLICATION_PUBLISH_ISSUES;
						this.dialog.show = true;
					} else {
						await this.publicationService.publishIssues(this.id);
						await this.init();
					}
					break;
				}
				case eParticaAction.PUBLICATION_UNPUBLISH_ISSUES: {
					const notlives = this.issues.filter(i => i.live === 1 && i.issueStatus === 1);
					if (notlives.length > 5) {
						this.dialog.title = "Unpublish multiple issues.";
						this.dialog.message = `You have chosen to unpublish ${notlives.length} issues. This will remove the issues from your site in the background using a background process.`;
						this.dialog.action = eParticaAction.CONFIRM_PUBLICATION_UNPUBLISH_ISSUES;
						this.dialog.show = true;
					} else {
						await this.publicationService.unPublishIssues(this.id);
						await this.init();
					}
					break;
				}
				case eParticaAction.CONFIRM_PUBLICATION_UNPUBLISH_ISSUES: {
					this.dialog.show = false;
					await this.publicationService.unPublishIssues(this.id);
					await this.init();
					break;
				}
				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}

	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Home";
		if (this.stateconfig.admin !== true) {
			this.advancedbuttons = [];
		}
		await this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			await this.getTitleNav(this.id);
			this.breadcrumbs.pop();
			this.publicationService = this.particaServices.getPublicationService();
			this.data = await this.publicationService.getTitle(this.id);
			this.issues = await this.publicationService.getIssues(this.id);
			this.issueService = this.particaServices.getIssueService();
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
